import React from 'react'
import { useMutation } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { cashinForMng } from 'services/loans'

export default function useSetCashinMng() {
    const navigate = useNavigate()
    const { isLoading, mutate } = useMutation({
        mutationFn: (payload: IFuckingPayload) => {
            return cashinForMng(payload)
        },
        onSuccess: (data) => {
            toast.success('واریز با موفقیت ثبت شد')
            navigate('/funds')
        },
        onError: () => {
            toast.error('خطایی رخ داده')
        },
    })

    return { isLoading, mutate }
}
